import { createAsyncThunk, createSlice, isAnyOf } from '@reduxjs/toolkit';
import { chirpClient } from '../../clients/chirpClient';
import { loginVerifyRpc } from '../../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/AccessRpc';
import { RequestStatus } from '../../constants/RequestStatus';
const initialState = {
  contact: null,
  isLoggedIn: false,
  requestStatus: RequestStatus.UNINITIALIZED,
  initialized: false,
  error: undefined
};
export const loginVerified = createAsyncThunk('auth/loginVerified', async () => {
  const response = await chirpClient.call(loginVerifyRpc, {
    request: {}
  });
  return response;
});
const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(loginVerified.fulfilled, (state, action) => {
      state.initialized = true;
      state.isLoggedIn = true;
      state.contact = action.payload;
    }).addCase(loginVerified.rejected, state => {
      state.initialized = true;
      state.isLoggedIn = false;
    }).addMatcher(isAnyOf(loginVerified.pending), state => {
      state.requestStatus = RequestStatus.PENDING;
      state.error = undefined;
    }).addMatcher(isAnyOf(loginVerified.fulfilled), state => {
      state.requestStatus = RequestStatus.SUCCEEDED;
    }).addMatcher(isAnyOf(loginVerified.rejected), (state, action) => {
      var _action$error;
      state.requestStatus = RequestStatus.FAILED;
      state.error = (_action$error = action.error) === null || _action$error === void 0 ? void 0 : _action$error.message;
    });
  }
});
export default authSlice.reducer;